export default {
	50: {
		a: 	 { m: { m: 5.7, f: 7.2 }, h: { m: 0.5, f: 0.8 } },
		as:  { m: { m: 9.2, f: 12 }, h: { m: 1.1, f: 1.7 } },
		ao:  { m: { m: 12, f: 12 }, h: { m: 5.1, f: 3.4 } },
		aso: { m: { m: 20, f: 19 }, h: { m: 9.2, f: 6.3 } }
	},
	51: {
		a: 	 { m: { m: 6, f: 7.7 }, h: { m: 0.6, f: 0.9 } },
		as:  { m: { m: 9.6, f: 13 }, h: { m: 1.2, f: 2 } },
		ao:  { m: { m: 13, f: 12 }, h: { m: 5.3, f: 3.6 } },
		aso: { m: { m: 21, f: 20 }, h: { m: 9.2, f: 6.6 } }
	},
	52: {
		a: 	 { m: { m: 6.2, f: 8.1 }, h: { m: 0.6, f: 1 } },
		as:  { m: { m: 9.8, f: 13 }, h: { m: 1.4, f: 2.2 } },
		ao:  { m: { m: 13, f: 13 }, h: { m: 5.5, f: 3.7 } },
		aso: { m: { m: 21, f: 21 }, h: { m: 9.8, f: 6.8 } }
	},
	53: {
		a: 	 { m: { m: 6.4, f: 8.5 }, h: { m: 0.7, f: 1.1 } },
		as:  { m: { m: 10, f: 14 }, h: { m: 1.5, f: 2.4 } },
		ao:  { m: { m: 14, f: 12 }, h: { m: 5.6, f: 3.8 } },
		aso: { m: { m: 22, f: 19 }, h: { m: 10, f: 7 } }
	},
	54: {
		a: 	 { m: { m: 6.6, f: 8.9 }, h: { m: 0.8, f: 1.2 } },
		as:  { m: { m: 10, f: 14 }, h: { m: 1.6, f: 2.6 } },
		ao:  { m: { m: 14, f: 13 }, h: { m: 5.6, f: 3.8 } },
		aso: { m: { m: 22, f: 22 }, h: { m: 10, f: 7.1 } }
	},
	55: {
		a: 	 { m: { m: 6.8, f: 9.4 }, h: { m: 0.8, f: 1.3 } },
		as:  { m: { m: 11, f: 15 }, h: { m: 1.7, f: 2.7 } },
		ao:  { m: { m: 14, f: 14 }, h: { m: 5.6, f: 3.8 } },
		aso: { m: { m: 22, f: 23 }, h: { m: 9.9, f: 7.1 } }
	},
	56: {
		a: 	 { m: { m: 7, f: 9.9 }, h: { m: 0.9, f: 1.5 } },
		as:  { m: { m: 11, f: 16 }, h: { m: 1.9, f: 3.1 } },
		ao:  { m: { m: 14, f: 15 }, h: { m: 5.8, f: 4.1 } },
		aso: { m: { m: 23, f: 24 }, h: { m: 10, f: 7.5 } }
	},
	57: {
		a: 	 { m: { m: 7.2, f: 10 }, h: { m: 1, f: 1.6 } },
		as:  { m: { m: 11, f: 17 }, h: { m: 2.1, f: 3.4 } },
		ao:  { m: { m: 14, f: 15 }, h: { m: 5.8, f: 4.2 } },
		aso: { m: { m: 23, f: 24 }, h: { m: 10, f: 7.7 } }
	},
	58: {
		a: 	 { m: { m: 7.4, f: 11 }, h: { m: 1, f: 1.8 } },
		as:  { m: { m: 12, f: 18 }, h: { m: 2.2, f: 3.7 } },
		ao:  { m: { m: 15, f: 16 }, h: { m: 5.8, f: 4.3 } },
		aso: { m: { m: 23, f: 25 }, h: { m: 10, f: 7.9 } }
	},
	59: {
		a: 	 { m: { m: 7.6, f: 11 }, h: { m: 1.2, f: 1.9 } },
		as:  { m: { m: 12, f: 18 }, h: { m: 2.4, f: 4 } },
		ao:  { m: { m: 15, f: 16 }, h: { m: 5.8, f: 4.4 } },
		aso: { m: { m: 23, f: 25 }, h: { m: 10, f: 8 } }
	},
	60: {
		a: 	 { m: { m: 7.8, f: 12 }, h: { m: 1.3, f: 1.2 } },
		as:  { m: { m: 12, f: 19 }, h: { m: 2.6, f: 4.3 } },
		ao:  { m: { m: 15, f: 16 }, h: { m: 5.7, f: 4.4 } },
		aso: { m: { m: 23, f: 26 }, h: { m: 10, f: 8 } }
	},
	61: {
		a: 	 { m: { m: 8.2, f: 13 }, h: { m: 1.4, f: 2.3 } },
		as:  { m: { m: 13, f: 21 }, h: { m: 2.8, f: 4.8 } },
		ao:  { m: { m: 15, f: 17 }, h: { m: 5.9, f: 4.6 } },
		aso: { m: { m: 10, f: 27 }, h: { m: 10, f: 8.4 } }
	},
	62: {
		a: 	 { m: { m: 8.6, f: 14 }, h: { m: 1.5, f: 2.5 } },
		as:  { m: { m: 13, f: 22 }, h: { m: 3.1, f: 5.3 } },
		ao:  { m: { m: 15, f: 18 }, h: { m: 5.9, f: 4.8 } },
		aso: { m: { m: 23, f: 28 }, h: { m: 10, f: 8.6 } }
	},
	63: {
		a: 	 { m: { m: 8.9, f: 15 }, h: { m: 1.7, f: 2.8 } },
		as:  { m: { m: 14, f: 23 }, h: { m: 3.3, f: 5.7 } },
		ao:  { m: { m: 15, f: 19 }, h: { m: 5.9, f: 4.9 } },
		aso: { m: { m: 23, f: 29 }, h: { m: 10, f: 8.8 } }
	},
	64: {
		a: 	 { m: { m: 9.2, f: 15 }, h: { m: 1.8, f: 3 } },
		as:  { m: { m: 14, f: 24 }, h: { m: 3.5, f: 6.1 } },
		ao:  { m: { m: 16, f: 19 }, h: { m: 5.9, f: 4.9 } },
		aso: { m: { m: 24, f: 30 }, h: { m: 10, f: 8.9 } }
	},
	65: {
		a: 	 { m: { m: 9.5, f: 16 }, h: { m: 1.8, f: 3.1 } },
		as:  { m: { m: 14, f: 26 }, h: { m: 3.5, f: 6.5 } },
		ao:  { m: { m: 16, f: 20 }, h: { m: 5.8, f: 4.9 } },
		aso: { m: { m: 24, f: 31 }, h: { m: 9.8, f: 8.9 } }
	},
	66: {
		a: 	 { m: { m: 9.7, f: 17 }, h: { m: 2.1, f: 3.5 } },
		as:  { m: { m: 15, f: 27 }, h: { m: 3.9, f: 7.2 } },
		ao:  { m: { m: 16, f: 20 }, h: { m: 5.9, f: 5.2 } },
		aso: { m: { m: 24, f: 31 }, h: { m: 9.8, f: 9.4 } }
	},
	67: {
		a: 	 { m: { m: 10, f: 18 }, h: { m: 2.2, f: 3.9 } },
		as:  { m: { m: 15, f: 28 }, h: { m: 4.2, f: 8 } },
		ao:  { m: { m: 16, f: 21 }, h: { m: 5.9, f: 5.5 } },
		aso: { m: { m: 23, f: 32 }, h: { m: 9.8, f: 9.7 } }
	},
	68: {
		a: 	 { m: { m: 10, f: 19 }, h: { m: 2.4, f: 4.2 } },
		as:  { m: { m: 15, f: 29 }, h: { m: 4.5, f: 8.6 } },
		ao:  { m: { m: 16, f: 21 }, h: { m: 5.9, f: 5.6 } },
		aso: { m: { m: 23, f: 33 }, h: { m: 9.7, f: 10 } }
	},
	69: {
		a: 	 { m: { m: 10, f: 19 }, h: { m: 2.6, f: 4.6 } },
		as:  { m: { m: 15, f: 30 }, h: { m: 4.7, f: 9.2 } },
		ao:  { m: { m: 16, f: 22 }, h: { m: 5.9, f: 5.7 } },
		aso: { m: { m: 23, f: 33 }, h: { m: 9.6, f: 10 } }
	},
	70: {
		a: 	 { m: { m: 11, f: 20 }, h: { m: 2.7, f: 4.8 } },
		as:  { m: { m: 16, f: 31 }, h: { m: 5, f: 9.7 } },
		ao:  { m: { m: 16, f: 22 }, h: { m: 5.9, f: 5.8 } },
		aso: { m: { m: 23, f: 33 }, h: { m: 9.5, f: 10 } }
	},
	71: {
		a: 	 { m: { m: 11, f: 21 }, h: { m: 2.9, f: 5.4 } },
		as:  { m: { m: 16, f: 32 }, h: { m: 5.3, f: 11 } },
		ao:  { m: { m: 15, f: 22 }, h: { m: 5.9, f: 6.1 } },
		aso: { m: { m: 22, f: 33 }, h: { m: 9.4, f: 11 } }
	},
	72: {
		a: 	 { m: { m: 11, f: 21 }, h: { m: 3.1, f: 5.9 } },
		as:  { m: { m: 15, f: 32 }, h: { m: 5.6, f: 12 } },
		ao:  { m: { m: 15, f: 22 }, h: { m: 5.9, f: 6.4 } },
		aso: { m: { m: 21, f: 33 }, h: { m: 9.3, f: 11 } }
	},
	73: {
		a: 	 { m: { m: 11, f: 22 }, h: { m: 3.4, f: 6.5 } },
		as:  { m: { m: 15, f: 33 }, h: { m: 5.9, f: 13 } },
		ao:  { m: { m: 15, f: 22 }, h: { m: 5.9, f: 6.7 } },
		aso: { m: { m: 21, f: 33 }, h: { m: 9.2, f: 12 } }
	},
	74: {
		a: 	 { m: { m: 11, f: 22 }, h: { m: 3.6, f: 6.9 } },
		as:  { m: { m: 15, f: 34 }, h: { m: 6.2, f: 13 } },
		ao:  { m: { m: 14, f: 0 }, h: { m: 5.9, f: 0 } },
		aso: { m: { m: 20, f: 0 }, h: { m: 9.2, f: 0 } }
	},
	75: {
		a: 	 { m: { m: 11, f: 23 }, h: { m: 3.8, f: 7.4 } },
		as:  { m: { m: 16, f: 34 }, h: { m: 6.6, f: 14 } },
		ao:  { m: { m: 14, f: 0 }, h: { m: 6, f: 0 } },
		aso: { m: { m: 20, f: 0 }, h: { m: 9.2, f: 0 } }
	},
	76: {
		a: 	 { m: { m: 11, f: 24 }, h: { m: 4.1, f: 8.1 } },
		as:  { m: { m: 15, f: 35 }, h: { m: 6.8, f: 15 } },
		ao:  { m: { m: 14, f: 0 }, h: { m: 5.9, f: 0 } },
		aso: { m: { m: 19, f: 0 }, h: { m: 8.9, f: 0 } }
	},
	77: {
		a: 	 { m: { m: 11, f: 25 }, h: { m: 4.3, f: 8.8 } },
		as:  { m: { m: 15, f: 36 }, h: { m: 7.1, f: 16 } },
		ao:  { m: { m: 13, f: 0 }, h: { m: 5.8, f: 0 } },
		aso: { m: { m: 18, f: 0 }, h: { m: 8.7, f: 0 } }
	},
	78: {
		a: 	 { m: { m: 11, f: 26 }, h: { m: 4.6, f: 9.4 } },
		as:  { m: { m: 15, f: 37 }, h: { m: 7.4, f: 17 } },
		ao:  { m: { m: 13, f: 0 }, h: { m: 5.8, f: 0 } },
		aso: { m: { m: 18, f: 0 }, h: { m: 8.6, f: 0 } }
	},
	79: {
		a: 	 { m: { m: 11, f: 27 }, h: { m: 4.8, f: 10 } },
		as:  { m: { m: 16, f: 38 }, h: { m: 7.8, f: 18 } },
		ao:  { m: { m: 13, f: 0 }, h: { m: 5.8, f: 0 } },
		aso: { m: { m: 17, f: 0 }, h: { m: 8.5, f: 0 } }
	},
	80: {
		a: 	 { m: { m: 12, f: 27 }, h: { m: 5.1, f: 10 } },
		as:  { m: { m: 16, f: 38 }, h: { m: 8.3, f: 19 } },
		ao:  { m: { m: 13, f: 0 }, h: { m: 5.9, f: 0 } },
		aso: { m: { m: 17, f: 0 }, h: { m: 8.7, f: 0 } }
	},
	81: {
		a: 	 { m: { m: 12, f: 29 }, h: { m: 5.5, f: 12 } },
		as:  { m: { m: 16, f: 39 }, h: { m: 8.6, f: 20 } },
		ao:  { m: { m: 13, f: 0 }, h: { m: 5.8, f: 0 } },
		aso: { m: { m: 17, f: 0 }, h: { m: 8.4, f: 0 } }
	},
	82: {
		a: 	 { m: { m: 12, f: 30 }, h: { m: 5.9, f: 13 } },
		as:  { m: { m: 16, f: 40 }, h: { m: 9, f: 21 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	83: {
		a: 	 { m: { m: 13, f: 31 }, h: { m: 6.3, f: 14 } },
		as:  { m: { m: 17, f: 41 }, h: { m: 9.5, f: 23 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	84: {
		a: 	 { m: { m: 13, f: 32 }, h: { m: 6.8, f: 15 } },
		as:  { m: { m: 17, f: 42 }, h: { m: 10, f: 24 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	85: {
		a: 	 { m: { m: 14, f: 33 }, h: { m: 7.5, f: 16 } },
		as:  { m: { m: 18, f: 43 }, h: { m: 11, f: 25 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	86: {
		a: 	 { m: { m: 14, f: 33 }, h: { m: 7.6, f: 16 } },
		as:  { m: { m: 18, f: 43 }, h: { m: 11, f: 26 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	87: {
		a: 	 { m: { m: 14, f: 33 }, h: { m: 7.8, f: 17 } },
		as:  { m: { m: 18, f: 42 }, h: { m: 11, f: 26 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	88: {
		a: 	 { m: { m: 14, f: 33 }, h: { m: 8.1, f: 17 } },
		as:  { m: { m: 18, f: 42 }, h: { m: 12, f: 26 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	89: {
		a: 	 { m: { m: 14, f: 33 }, h: { m: 8.6, f: 17 } },
		as:  { m: { m: 19, f: 42 }, h: { m: 13, f: 27 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	},
	90: {
		a: 	 { m: { m: 15, f: 34 }, h: { m: 9.4, f: 18 } },
		as:  { m: { m: 20, f: 43 }, h: { m: 14, f: 28 } },
		ao:  { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } },
		aso: { m: { m: 0, f: 0 }, h: { m: 0, f: 0 } }
	}
}